import { render, staticRenderFns } from "./rolepeople.vue?vue&type=template&id=e21eb354&scoped=true&"
import script from "./rolepeople.vue?vue&type=script&lang=js&"
export * from "./rolepeople.vue?vue&type=script&lang=js&"
import style0 from "./rolepeople.vue?vue&type=style&index=0&id=e21eb354&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e21eb354",
  null
  
)

export default component.exports